<template>
  <div class="fixed-content" :class="{ 'header-scrolled': scrollON }">

    <!-- ── Top Bar ─────────────────────────────────────────── -->
    <div class="header-topbar">
      <div class="container-nav-saik">

        <!-- Logo + brand name -->
        <div class="img-logo-header">
          <router-link to="/" class="logo-link">
            <img src="@/assets/images/papua/papua-logo.png" alt="SIO Papua" />
            <div class="logo-text">
              <span class="logo-title">SIO Papua</span>
              <span class="logo-sub">Sistem Informasi OAP</span>
            </div>
          </router-link>
        </div>

        <!-- Actions -->
        <div class="topbar-actions">
          <b-nav-item-dropdown class="nav-top-borderless" right>
            <template v-slot:button-content>
              <span class="btn-help-topbar">
                <svg class="btn-icon-svg" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                <span class="btn-help-text">Bantuan</span>
              </span>
            </template>
            <b-dropdown-item href="#">Troubleshoot</b-dropdown-item>
            <b-dropdown-item href="/bantuan/faq">FAQ</b-dropdown-item>
            <b-dropdown-item href="/bantuan/dokumentasi">Dokumentasi</b-dropdown-item>
            <b-dropdown-item href="/bantuan/tentangkami">Tentang Kami</b-dropdown-item>
          </b-nav-item-dropdown>

          <a
            class="btn-login-topbar"
            href="https://admin.siopapua.papua.go.id/siopapua-login"
          >
            <b-icon icon="person-fill" font-scale="0.9"></b-icon>
            Login
          </a>
        </div>

      </div>
    </div>

    <!-- ── Main Navigation ────────────────────────────────── -->
    <div
      class="header-navbar shadow-responsive"
      :class="{ activeScroll: scrollON }"
    >
      <div class="container-nav-saik">
        <div class="margin-auto width-100 bottom-navigation">
          <b-navbar toggleable="lg" type="dark">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto sub-nav" right>

                <b-nav-item to="/" exact>
                  <b-navbar-brand class="mr-2 ml-2">Home</b-navbar-brand>
                </b-nav-item>

                <b-nav-item
                  to="/berita"
                  :class="{ 'router-link-isactive': subIsActive(['/berita/detail/:id']) }"
                  exact
                >
                  <b-navbar-brand class="mr-2 ml-2">Berita</b-navbar-brand>
                </b-nav-item>

                <b-nav-item-dropdown
                  class="mr-2 ml-2 dropdown-style"
                  text="Data Pokok"
                  :class="{ 'router-link-isactive': subIsActive(['/data-pokok/']) }"
                >
                  <b-dropdown-item href="/data-pokok/data-kependudukan/">Data Kependudukan</b-dropdown-item>
                  <b-dropdown-item href="/data-pokok/data-kesehatan/">Data Kesehatan</b-dropdown-item>
                  <b-dropdown-item href="/data-pokok/data-pendidikan/">Data Pendidikan</b-dropdown-item>
                  <b-dropdown-item href="/data-pokok/data-bantuan-sosial/">Data Bantuan Sosial</b-dropdown-item>
                  <b-dropdown-item href="#">Data Keuangan</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item
                  to="/repository"
                  :class="{ 'router-link-isactive': subIsActive(['/repository']) }"
                  exact
                >
                  <b-navbar-brand class="mr-2 ml-2">Repository</b-navbar-brand>
                </b-nav-item>

                <b-nav-item
                  to="/potensi-kampung"
                  :class="{ 'router-link-isactive': subIsActive(['/potensi-kampung']) }"
                  exact
                >
                  <b-navbar-brand class="mr-2 ml-2">Potensi Kampung</b-navbar-brand>
                </b-nav-item>

                <b-nav-item-dropdown
                  class="mr-2 ml-2 dropdown-style"
                  text="Layanan"
                  :class="{ 'router-link-isactive': subIsActive(['/layanan/']) }"
                >
                  <b-dropdown-item href="/layanan/administrasi-kependudukan">Administrasi Kependudukan</b-dropdown-item>
                  <b-dropdown-item href="#">Mutasi</b-dropdown-item>
                  <b-dropdown-item href="#">Pertahanan</b-dropdown-item>
                  <b-dropdown-item href="https://admin.siopapua.papua.go.id/admin/letter/new">Surat Menyurat</b-dropdown-item>
                </b-nav-item-dropdown>

              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      windowTop: 0,
      scrollON: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.windowTop = window.scrollY;
      this.scrollON = this.windowTop >= 10;
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => this.$route.path.indexOf(path) === 0);
    },
  },
};
</script>
